import { useTranslation } from 'react-i18next'
import { MainContentArea } from '@/components/layout/MainContentArea'
import { RichContent } from '@/components/content/RichContent'
import { useContentBundle } from '@/hooks/useContentBundle'
import { AdditionalReadingCategory } from '@/types/api'

export function ReleaseNotesPage() {
  const { t } = useTranslation()
  const { data: bundle, isLoading } = useContentBundle()

  if (isLoading) {
    return (
      <MainContentArea>
        <div className="loading-state">{t('pages.loading')}</div>
      </MainContentArea>
    )
  }

  if (!bundle) {
    return (
      <MainContentArea>
        <div className="error-state">{t('content.unavailable')}</div>
      </MainContentArea>
    )
  }

  const items = bundle.additionalReading
    .filter((r) => r.category === AdditionalReadingCategory.ReleaseNotes)
    .sort((a, b) => a.sortOrder - b.sortOrder)

  return (
    <MainContentArea>
      {items.length === 0 ? (
        <p className="empty-state">{t('pages.noReleaseNotes')}</p>
      ) : (
        items.map((item) => (
          <div key={item.id} className="section-block" id={`reading-${item.id}`}>
            <h2 className="section-heading">
              {item.displayName}
              {item.isDraft && (
                <span className="tree-draft-badge" title={t('draftPreview.itemBadgeAdditionalReading')} aria-label={t('draftPreview.itemBadgeAdditionalReading')}>
                  {t('sidebar.draftBadgeLabel')}
                </span>
              )}
            </h2>
            <RichContent html={item.content ?? ''} original={item.originalFields?.content} bundle={bundle} />
          </div>
        ))
      )}
    </MainContentArea>
  )
}
